const translations = {
  // Nav
  "nav.home": "Startseite",
  "nav.mission": "Mission",
  "nav.projects": "Projekte",
  "nav.stories": "Geschichten",
  "nav.volunteer": "Ehrenamt",
  "nav.donate": "Spenden",
  "nav.contact": "Kontakt",
  "nav.donateNow": "Jetzt spenden",

  // Language bar
  "lang.managed": "Verwaltet über das Admin-CMS-Dashboard",

  // Hero
  "hero.badge": "Brücken bauen · Hoffnung schaffen",
  "hero.title": "Afghanische Gemeinschaften durch Bildung und Chancen stärken",
  "hero.subtitle": "Die Canada Afghanistan Foundation verbindet mitfühlende Kanadier mit bedürftigen afghanischen Gemeinschaften — Finanzierung von Bildung, Gesundheitsversorgung und nachhaltiger Entwicklung seit 2016.",
  "hero.cta.donate": "Unsere Mission unterstützen",
  "hero.cta.learn": "Unsere Geschichte",
  "hero.scroll": "Scrollen",
  "hero.stats": "[{\"label\":\"Unterstützte Schüler\",\"value\":\"2.500+\"},{\"label\":\"Aktive Projekte\",\"value\":\"15\"},{\"label\":\"Jahre Wirkung\",\"value\":\"8\"},{\"label\":\"Freiwillige\",\"value\":\"340+\"}]",

  // Mission Preview
  "mission.tag": "Unsere Mission",
  "mission.title": "Eine Brücke zwischen zwei Nationen, gebaut auf Mitgefühl",
  "mission.body1": "Die Canada Afghanistan Foundation (CAF) ist eine registrierte kanadische Wohltätigkeitsorganisation, die sich der Verbesserung des Lebens der Afghanen durch gezielte Programme in Bildung, Gesundheitsversorgung und Gemeindeentwicklung widmet.",
  "mission.body2": "Wir glauben, dass jedes afghanische Kind Zugang zu Bildung verdient, jede Familie sauberes Wasser verdient und jede Gemeinschaft die Chance verdient zu gedeihen — unabhängig von Konflikten.",
  "mission.cta": "Unsere vollständige Mission lesen",
  "mission.pillar.education": "Bildung",
  "mission.pillar.education.desc": "Finanzierung von Schulen, Stipendien und Berufsausbildung für afghanische Jugendliche und Frauen.",
  "mission.pillar.healthcare": "Gesundheit",
  "mission.pillar.healthcare.desc": "Einsatz mobiler Kliniken und Unterstützung medizinischer Fachkräfte in unterversorgten Regionen.",
  "mission.pillar.community": "Gemeinschaft",
  "mission.pillar.community.desc": "Aufbau von Infrastruktur, Zugang zu sauberem Wasser und Unterstützung der Flüchtlingsumsiedlung in Kanada.",
  "mission.pillar.sustainability": "Nachhaltigkeit",
  "mission.pillar.sustainability.desc": "Stärkung lokaler Führungskräfte und Organisationen für dauerhaften, selbsttragenden Wandel.",

  // Projects Preview
  "projects.tag": "Aktive Initiativen",
  "projects.title": "Unsere aktuellen Projekte",
  "projects.subtitle": "Jedes Projekt ist sorgfältig darauf ausgelegt, nachhaltige Wirkung in afghanischen Gemeinschaften zu erzielen.",
  "projects.viewAll": "Alle Projekte anzeigen",
  "projects.learnMore": "Mehr erfahren",
  "projects.raised": "Gesammelt",
  "projects.completed": "Abgeschlossen",

  // Impact
  "impact.tag": "Unsere Wirkung",
  "impact.title": "Echter Wandel, echte Zahlen",
  "impact.subtitle": "Jeder gespendete Dollar führt zu messbarer Wirkung vor Ort. Das haben wir gemeinsam erreicht.",
  "impact.students": "Unterstützte Schüler",
  "impact.students.desc": "Mädchen und Jungen, die durch unsere Stipendien- und Schulprogramme Qualitätsbildung erhalten.",
  "impact.water": "Menschen mit sauberem Wasser",
  "impact.water.desc": "Familien im ländlichen Afghanistan haben jetzt Zugang zu sicherem, sauberem Trinkwasser.",
  "impact.medical": "Medizinische Konsultationen",
  "impact.medical.desc": "Kostenlose Gesundheitsversorgung durch unser mobiles Klinikprogramm seit 2018.",
  "impact.families": "Umgesiedelte Familien",
  "impact.families.desc": "Afghanische Flüchtlingsfamilien, die in ihrem neuen Leben in Kanada unterstützt werden.",

  // Volunteer Preview
  "volunteer.tag": "Mitmachen",
  "volunteer.title": "Treten Sie unserer Gemeinschaft von Veränderern bei",
  "volunteer.body1": "Ob Arzt, Übersetzer, Fundraiser oder Social-Media-Enthusiast — bei der CAF ist Platz für Sie. Ihre Fähigkeiten können Leben verändern.",
  "volunteer.body2": "Wir haben Freiwilligenmöglichkeiten für Kanadier und Mitglieder der afghanischen Diaspora, sowohl remote als auch vor Ort.",
  "volunteer.cta": "Freiwilliger werden",
  "volunteer.otherWays": "Oder erkunden Sie andere Möglichkeiten zu helfen",
  "volunteer.apply": "Bewerben",
  "volunteer.location": "Ort",

  // Donate Preview
  "donate.tag": "Einen Unterschied machen",
  "donate.title": "Ihre Spende, ihre Zukunft",
  "donate.subtitle": "100% Ihrer Spende fließt direkt in Programme vor Ort. Wir sind eine registrierte kanadische Wohltätigkeitsorganisation — alle Spenden sind steuerlich absetzbar.",
  "donate.tier.supporter": "Unterstützer",
  "donate.tier.champion": "Champion",
  "donate.tier.patron": "Mäzen",
  "donate.mostPopular": "Am beliebtesten",
  "donate.highImpact": "Hohe Wirkung",
  "donate.donate": "Spenden",
  "donate.trust.charity": "Registrierte kanadische Wohltätigkeitsorganisation",
  "donate.trust.transparent": "100% Transparent",
  "donate.trust.receipts": "Steuerquittungen ausgestellt",
  "donate.trust.secure": "Sichere Verarbeitung",
  "donate.newsletter.title": "Bleiben Sie über unsere Wirkung informiert",
  "donate.newsletter.desc": "Abonnieren Sie unseren Newsletter für monatliche Updates zu Projekten, Geschichten und Möglichkeiten zu helfen.",
  "donate.newsletter.placeholder": "Ihre E-Mail-Adresse",
  "donate.newsletter.button": "Abonnieren",
  "donate.newsletter.subscribing": "Wird abonniert...",
  "donate.newsletter.success": "Vielen Dank für Ihr Abonnement! Wir halten Sie auf dem Laufenden.",
  "donate.newsletter.error": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",

  // Footer
  "footer.tagline": "Brücken zwischen Kanada und Afghanistan durch Bildung, Gesundheitsversorgung und Gemeindeentwicklung bauen.",
  "footer.charity": "Registrierte Wohltätigkeitsorganisation",
  "footer.quickLinks": "Schnelllinks",
  "footer.getInvolved": "Mitmachen",
  "footer.stayConnected": "Verbunden bleiben",
  "footer.newsletter.desc": "Erhalten Sie monatliche Updates über unsere Wirkung und wie Sie helfen können.",
  "footer.newsletter.placeholder": "Ihre E-Mail-Adresse",
  "footer.newsletter.success": "Vielen Dank für Ihre Anmeldung!",
  "footer.newsletter.privacy": "Wir respektieren Ihre Privatsphäre. Jederzeit abmelden.",
  "footer.involved.volunteer": "Ehrenamtliche Möglichkeiten",
  "footer.involved.partnerships": "Unternehmenspartnerschaften",
  "footer.involved.fundraise": "Spendenaktion für CAF",
  "footer.involved.reports": "Jahresberichte",
  "footer.involved.transparency": "Finanzielle Transparenz",
  "footer.involved.news": "Neuigkeiten & Updates",
  "footer.support": "Support verfügbar in:",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.terms": "Nutzungsbedingungen",
  "footer.accessibility": "Barrierefreiheit",
  "footer.admin": "Admin",
  "footer.copyright": "Canada Afghanistan Foundation. Alle Rechte vorbehalten.",

  // Contact
  "contact.tag": "Kontakt aufnehmen",
  "contact.title": "Wir freuen uns von Ihnen zu hören",
  "contact.subtitle": "Fragen zu unseren Programmen oder möchten Sie mit uns zusammenarbeiten? Kontaktieren Sie uns — wir antworten auf Englisch, Paschtu, Dari, Französisch und Deutsch.",
  "contact.form.name": "Vollständiger Name",
  "contact.form.email": "E-Mail-Adresse",
  "contact.form.subject": "Betreff",
  "contact.form.message": "Ihre Nachricht",
  "contact.form.submit": "Nachricht senden",
  "contact.form.sending": "Wird gesendet...",
  "contact.form.success": "Nachricht gesendet! Wir melden uns innerhalb von 48 Stunden.",
  "contact.info.address": "Adresse",
  "contact.info.email": "E-Mail",
  "contact.info.phone": "Telefon",
  "contact.info.hours": "Bürozeiten",

  // ========== MISSION PAGE ==========
  "missionPage.tag": "Unsere Mission",
  "missionPage.title": "Eine Mission verwurzelt in Hoffnung, angetrieben von Handeln",
  "missionPage.subtitle": "Die Canada Afghanistan Foundation existiert, um die Lücke zwischen mitfühlenden Kanadiern und bedürftigen afghanischen Gemeinschaften zu überbrücken.",
  "missionPage.who.tag": "Wer wir sind",
  "missionPage.who.title": "Brücken zwischen zwei Nationen bauen",
  "missionPage.who.body1": "Gegründet 2016 von afghanisch-kanadischen Gemeindeführern, ist CAF eine registrierte kanadische Wohltätigkeitsorganisation, die sich der Verbesserung des Lebens der Afghanen durch gezielte, transparente und wirkungsvolle Programme widmet.",
  "missionPage.who.body2": "Wir glauben, dass Geografie und Konflikte niemals den Zugang eines Kindes zu Bildung, den Zugang einer Familie zu sauberem Wasser oder die Fähigkeit einer Gemeinschaft zu gedeihen bestimmen sollten. Unsere Arbeit wird vom Prinzip geleitet, dass nachhaltiger Wandel von innen kommt — wir befähigen, nicht ersetzen.",
  "missionPage.who.body3": "Mit einem Freiwilligennetzwerk von über 340 engagierten Personen in Kanada und Afghanistan und Partnerschaften mit lokalen afghanischen NGOs stellen wir sicher, dass jeder Dollar diejenigen erreicht, die ihn am meisten brauchen.",
  "missionPage.who.ctaProjects": "Unsere Projekte ansehen",
  "missionPage.who.ctaSupport": "Unterstützen Sie uns",
  "missionPage.who.yearsBadge": "Jahre Wirkung",
  "missionPage.values.tag": "Was uns leitet",
  "missionPage.values.title": "Unsere Grundwerte",
  "missionPage.values.compassion": "Mitgefühl",
  "missionPage.values.compassionDesc": "Wir handeln mit Empathie und Fürsorge für jeden Einzelnen, dem wir dienen, unabhängig von Hintergrund oder Umständen.",
  "missionPage.values.integrity": "Integrität",
  "missionPage.values.integrityDesc": "Wir arbeiten mit vollständiger finanzieller Transparenz und Rechenschaftspflicht gegenüber unseren Spendern und den Gemeinschaften, denen wir dienen.",
  "missionPage.values.collaboration": "Zusammenarbeit",
  "missionPage.values.collaborationDesc": "Wir arbeiten mit lokalen afghanischen Organisationen, kanadischen Institutionen und globalen NGOs zusammen, um die Wirkung zu maximieren.",
  "missionPage.values.sustainability": "Nachhaltigkeit",
  "missionPage.values.sustainabilityDesc": "Wir entwerfen Programme, die Gemeinschaften befähigen, im Laufe der Zeit selbstständig und widerstandsfähig zu werden.",
  "missionPage.values.equity": "Gerechtigkeit",
  "missionPage.values.equityDesc": "Wir priorisieren die Schwächsten — Frauen, Kinder und vertriebene Familien — in all unseren Programmen.",
  "missionPage.values.innovation": "Innovation",
  "missionPage.values.innovationDesc": "Wir suchen kontinuierlich nach kreativen, evidenzbasierten Lösungen für komplexe humanitäre Herausforderungen.",
  "missionPage.timeline.tag": "Unsere Reise",
  "missionPage.timeline.title": "8 Jahre Wirkung",
  "missionPage.timeline.2016": "CAF in Ottawa von afghanisch-kanadischen Gemeindeführern gegründet",
  "missionPage.timeline.2017": "Erstes Stipendienprogramm für Mädchenbildung in Kabul gestartet",
  "missionPage.timeline.2018": "Mobiles Gesundheitsklinikprogramm in der Provinz Nangarhar eingesetzt",
  "missionPage.timeline.2019": "Sauberwasser-Initiative erreicht 5.000 Familien in Helmand",
  "missionPage.timeline.2020": "COVID-19 Nothilfe — Verteilung von Schutzausrüstung und Lebensmitteln an 3.000 Familien",
  "missionPage.timeline.2021": "Flüchtlingsumsiedlungsprogramm in Toronto und Ottawa gestartet",
  "missionPage.timeline.2022": "Berufsbildungszentren in Herat und Mazar-i-Sharif eröffnet",
  "missionPage.timeline.2023": "Erweiterung auf 15 aktive Projekte in 8 afghanischen Provinzen",
  "missionPage.timeline.2024": "2.500+ Schüler unterstützt; 18.000+ Menschen mit Zugang zu sauberem Wasser",
  "missionPage.cta.title": "Teil der Mission sein",
  "missionPage.cta.subtitle": "Ob Sie spenden, ehrenamtlich tätig sind oder einfach das Wort verbreiten — Sie sind Teil des Wandels.",
  "missionPage.cta.donate": "Jetzt spenden",
  "missionPage.cta.volunteer": "Freiwilliger werden",

  // ========== PROJECTS PAGE ==========
  "projectsPage.tag": "Was wir tun",
  "projectsPage.title": "Unsere Projekte",
  "projectsPage.subtitle": "Von Klassenzimmern in Kabul bis zu Wasserbrunnen in Helmand — jedes Projekt ist ein Schritt in Richtung eines besseren Afghanistans.",
  "projectsPage.filters.all": "Alle",
  "projectsPage.filters.education": "Bildung",
  "projectsPage.filters.healthcare": "Gesundheit",
  "projectsPage.filters.infrastructure": "Infrastruktur",
  "projectsPage.filters.community": "Gemeinschaft",
  "projectsPage.filters.humanitarian": "Humanitär",
  "projectsPage.status.all": "Alle",
  "projectsPage.status.active": "Aktiv",
  "projectsPage.status.completed": "Abgeschlossen",
  "projectsPage.empty": "Keine Projekte für diesen Filter gefunden.",
  "projectsPage.details": "Details",
  "projectsPage.raised": "Gesammelt",
  "projectsPage.progress": "Fortschritt",
  "projectsPage.beneficiaries": "Begünstigte",
  "projectsPage.badge.completed": "Abgeschlossen",

  // ========== PROJECT DETAIL PAGE ==========
  "projectDetail.home": "Startseite",
  "projectDetail.projects": "Projekte",
  "projectDetail.notFound": "Projekt nicht gefunden",
  "projectDetail.notFound.back": "Zurück zu Projekten",
  "projectDetail.funding.title": "Finanzierungsfortschritt",
  "projectDetail.funding.raised": "gesammelt von",
  "projectDetail.funding.goal": "Ziel",
  "projectDetail.funding.complete": "Abgeschlossen",
  "projectDetail.funding.funded": "finanziert",
  "projectDetail.funding.cta": "Für dieses Projekt spenden",
  "projectDetail.details.title": "Projektdetails",
  "projectDetail.details.category": "Kategorie",
  "projectDetail.details.location": "Standort",
  "projectDetail.details.beneficiaries": "Begünstigte",
  "projectDetail.details.status": "Status",
  "projectDetail.details.statusActive": "Aktiv",
  "projectDetail.details.statusCompleted": "Abgeschlossen",
  "projectDetail.body1": "Diese Initiative ist Teil des umfassenderen Engagements von CAF für eine nachhaltige, gemeinschaftsgeführte Entwicklung in Afghanistan.",
  "projectDetail.body2": "Alle gesammelten Mittel fließen direkt in die Programmdurchführung. CAF gewährleistet vollständige finanzielle Transparenz.",
  "projectDetail.back": "Zurück zu allen Projekten",
  "projectDetail.beneficiariesSuffix": "Begünstigte",

  // ========== VOLUNTEER PAGE ==========
  "volunteerPage.tag": "Ehrenamt bei der CAF",
  "volunteerPage.title": "Ihre Fähigkeiten können Leben verändern",
  "volunteerPage.subtitle": "Treten Sie unserem globalen Netzwerk engagierter Freiwilliger bei, die einen Unterschied für afghanische Gemeinschaften machen.",
  "volunteerPage.positions.tag": "Offene Stellen",
  "volunteerPage.positions.title": "Aktuelle Freiwilligenmöglichkeiten",
  "volunteerPage.stories.tag": "Freiwilligengeschichten",
  "volunteerPage.stories.title": "Hören Sie von unseren Freiwilligen",
  "volunteerPage.apply.title": "Als Freiwilliger bewerben",
  "volunteerPage.apply.submitted": "Bewerbung eingereicht!",
  "volunteerPage.apply.submittedDesc": "Vielen Dank für Ihr Interesse. Unser Team wird Sie innerhalb von 3-5 Werktagen kontaktieren.",
  "volunteerPage.apply.close": "Schließen",
  "volunteerPage.form.name": "Vollständiger Name *",
  "volunteerPage.form.namePlaceholder": "Ihr vollständiger Name",
  "volunteerPage.form.email": "E-Mail-Adresse *",
  "volunteerPage.form.emailPlaceholder": "ihre@email.com",
  "volunteerPage.form.message": "Warum möchten Sie freiwillig mitarbeiten? *",
  "volunteerPage.form.messagePlaceholder": "Erzählen Sie uns von Ihrem Hintergrund und Ihrer Motivation...",
  "volunteerPage.form.submit": "Bewerbung einreichen",
  "volunteerPage.form.submitting": "Wird eingereicht...",
  "volunteerPage.spotsAvailable": "Plätze verfügbar",
  "volunteerPage.applyNow": "Jetzt bewerben",

  // ========== DONATE PAGE ==========
  "donatePage.tag": "Unsere Arbeit unterstützen",
  "donatePage.title": "Nachhaltige Wirkung erzielen",
  "donatePage.subtitle": "Ihre Großzügigkeit finanziert echte Programme, die echte Leben verändern.",
  "donatePage.yourImpact": "Ihre Wirkung",
  "donatePage.howToDonate": "So spenden Sie",
  "donatePage.tier.friend.label": "Freund",
  "donatePage.tier.friend.impact": "Stellt Schulmaterial für 2 Schüler bereit",
  "donatePage.tier.supporter.label": "Unterstützer",
  "donatePage.tier.supporter.impact": "Stellt Schulmaterial für 5 Schüler für ein Semester bereit",
  "donatePage.tier.advocate.label": "Fürsprecher",
  "donatePage.tier.advocate.impact": "Finanziert sauberes Wasser für eine Familie für 2 Monate",
  "donatePage.tier.champion.label": "Champion",
  "donatePage.tier.champion.impact": "Finanziert einen Monat sauberes Wasser für eine 6-köpfige Familie",
  "donatePage.tier.benefactor.label": "Wohltäter",
  "donatePage.tier.benefactor.impact": "Deckt die medizinische Versorgung von 10 Patienten in unserer mobilen Klinik",
  "donatePage.tier.patron.label": "Mäzen",
  "donatePage.tier.patron.impact": "Finanziert ein volles Jahr Sekundarschulbildung für ein Mädchen",
  "donatePage.custom.label": "Individueller Betrag (CAD)",
  "donatePage.custom.placeholder": "Betrag eingeben",
  "donatePage.custom.note": "Für individuelle Spenden kontaktieren Sie uns bitte direkt, um die Zahlung zu vereinbaren.",
  "donatePage.custom.contact": "Kontaktieren Sie uns",
  "donatePage.bank.title": "Banküberweisung",
  "donatePage.bank.desc": "Überweisen Sie direkt auf unser kanadisches Bankkonto:",
  "donatePage.bank.name": "Canada Afghanistan Foundation",
  "donatePage.bank.bank": "Bank",
  "donatePage.bank.bankName": "Royal Bank of Canada (RBC)",
  "donatePage.bank.accountName": "Kontoname",
  "donatePage.bank.accountNum": "Kontonummer",
  "donatePage.bank.transit": "Transitnummer",
  "donatePage.bank.institution": "Institutionsnummer",
  "donatePage.bank.warning": "Wichtig: Bitte geben Sie Ihren vollständigen Namen und Ihre E-Mail-Adresse im Verwendungszweck an, damit wir Ihre Steuerquittung ausstellen können.",
  "donatePage.cheque.title": "Scheck",
  "donatePage.cheque.desc": "Senden Sie einen Scheck, ausgestellt auf:",
  "donatePage.cheque.warning": "Bitte schreiben Sie Ihre E-Mail-Adresse auf die Rückseite des Schecks, um Ihre Steuerquittung zu erhalten.",
  "donatePage.inperson.title": "Persönlich",
  "donatePage.inperson.desc": "Besuchen Sie unser Büro während der Geschäftszeiten:",
  "donatePage.inperson.note": "Wir akzeptieren Bargeld, Scheck und Debit-/Kreditkarten vor Ort.",
  "donatePage.tax.title": "Steuerquittungen",
  "donatePage.tax.desc": "CAF ist eine registrierte kanadische Wohltätigkeitsorganisation. Alle Spenden über 20 CAD sind für eine Steuerquittung berechtigt, die innerhalb von 30 Tagen ausgestellt wird.",
  "donatePage.trust.charity": "Registrierte Wohltätigkeitsorganisation",
  "donatePage.trust.transparent": "100% Transparent",
  "donatePage.trust.secure": "Sicher & Geschützt",
  "donatePage.trust.programs": "100% für Programme",
  "donatePage.bottom.title": "Fragen zum Spenden?",
  "donatePage.bottom.subtitle": "Unser Team hilft Ihnen gerne, die wirkungsvollste Spende zu tätigen.",
  "donatePage.bottom.contact": "Kontaktieren Sie unser Team",

  // ========== CONTACT PAGE ==========
  "contactPage.tag": "Kontakt aufnehmen",
  "contactPage.title": "Kontakt & Support",
  "contactPage.subtitle": "Haben Sie eine Frage, möchten Sie mit uns zusammenarbeiten oder benötigen Sie Unterstützung? Wir sind für Sie da — auf Englisch, Paschtu und Dari.",
  "contactPage.form.title": "Senden Sie uns eine Nachricht",
  "contactPage.form.submitted": "Nachricht gesendet!",
  "contactPage.form.submittedDesc": "Vielen Dank für Ihre Nachricht. Unser Team wird innerhalb von 2-3 Werktagen antworten.",
  "contactPage.form.another": "Weitere Nachricht senden",
  "contactPage.form.name": "Vollständiger Name *",
  "contactPage.form.namePlaceholder": "Ihr vollständiger Name",
  "contactPage.form.email": "E-Mail-Adresse *",
  "contactPage.form.emailPlaceholder": "ihre@email.com",
  "contactPage.form.phone": "Telefonnummer",
  "contactPage.form.phonePlaceholder": "+1 (613) 555-0000",
  "contactPage.form.subject": "Betreff *",
  "contactPage.form.subjectPlaceholder": "Betreff auswählen",
  "contactPage.form.subjectOptions.general": "Allgemeine Anfrage",
  "contactPage.form.subjectOptions.donation": "Spendenfrage",
  "contactPage.form.subjectOptions.volunteer": "Freiwilligenbewerbung",
  "contactPage.form.subjectOptions.partnership": "Partnerschaftsvorschlag",
  "contactPage.form.subjectOptions.media": "Medien & Presse",
  "contactPage.form.subjectOptions.tech": "Technischer Support",
  "contactPage.form.subjectOptions.other": "Sonstiges",
  "contactPage.form.message": "Nachricht *",
  "contactPage.form.messagePlaceholder": "Wie können wir Ihnen helfen?",
  "contactPage.form.submit": "Nachricht senden",
  "contactPage.form.sending": "Wird gesendet...",
  "contactPage.form.error": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut oder senden Sie uns direkt eine E-Mail.",
  "contactPage.form.charLimit": "Die Nachricht darf maximal 500 Zeichen lang sein.",
  "contactPage.form.privacy": "Wir respektieren Ihre Privatsphäre. Ihre Daten werden niemals an Dritte weitergegeben.",
  "contactPage.office.title": "Unser Büro",
  "contactPage.office.address": "Adresse",
  "contactPage.office.addressValue": "123 Rideau Street, Suite 400\nOttawa, Ontario K1N 5Y1, Kanada",
  "contactPage.office.hours": "Bürozeiten",
  "contactPage.office.hoursValue": "Mo – Fr: 9:00 – 17:00 Uhr EST",
  "contactPage.office.phone": "Telefon",
  "contactPage.office.email": "E-Mail",
  "contactPage.map.directions": "Route berechnen",
  "contactPage.lang.title": "Mehrsprachiger Support",
  "contactPage.lang.desc": "Wir bieten Support auf Englisch, Paschtu und Dari. Bitte geben Sie Ihre bevorzugte Sprache in Ihrer Nachricht an.",

  // ========== STORIES PAGE ==========
  "storiesPage.tag": "Unsere Geschichten",
  "storiesPage.title": "Geschichten der Wirkung & Hoffnung",
  "storiesPage.subtitle": "Lesen Sie Berichte aus erster Hand, treffen Sie die Menschen hinter unserer Mission und bleiben Sie auf dem Laufenden.",
  "storiesPage.filters.all": "Alle",
  "storiesPage.filters.fieldStories": "Feldgeschichten",
  "storiesPage.filters.impactReports": "Wirkungsberichte",
  "storiesPage.filters.volunteerVoices": "Freiwilligenstimmen",
  "storiesPage.filters.news": "Nachrichten & Updates",
  "storiesPage.empty": "Keine Geschichten für diese Kategorie gefunden.",
  "storiesPage.readMore": "Weiterlesen",
  "storiesPage.backToStories": "Zurück zu allen Geschichten",
  "storiesPage.by": "von",
  "storiesPage.published": "Veröffentlicht",

  // Stories Preview (Home)
  "storiesPreview.tag": "Aus dem Feld",
  "storiesPreview.title": "Geschichten der Wirkung & Hoffnung",
  "storiesPreview.subtitle": "Echte Geschichten aus den Gemeinschaften, denen wir dienen — erzählt von den Menschen, die den Wandel jeden Tag erleben.",
  "storiesPreview.viewAll": "Alle Geschichten lesen",

  // Photo Slider (Home)
  "photoSlider.tag": "Vor Ort",
  "photoSlider.title": "Unsere Arbeit in Bildern",
  "photoSlider.subtitle": "Sehen Sie die Wirkung Ihrer Unterstützung — echte Momente aus unseren Projekten in Afghanistan und Kanada.",

  // Common
  "common.loading": "Wird geladen...",
  "common.retry": "Wiederholen",

  // Error / Empty states
  "storiesPage.errorTitle": "Geschichten konnten nicht geladen werden",
  "storiesPage.retry": "Wiederholen",
  "storiesPage.emptyTitle": "Noch keine Geschichten",
  "storiesPage.emptySubtitle": "Schauen Sie bald wieder vorbei für Updates vom Einsatzgebiet.",
  "photoSlider.errorTitle": "Fotos konnten nicht geladen werden",
  "photoSlider.empty": "Keine Fotos verfügbar. Fügen Sie Fotos im Admin-Dashboard hinzu.",
  "projectsPage.errorTitle": "Projekte konnten nicht geladen werden",
  "projectsPage.emptyTitle": "Noch keine Projekte",
  "projectsPage.emptySubtitle": "Neue Projekte werden hier angezeigt, sobald sie hinzugefügt werden.",
  "volunteerPage.errorTitle": "Möglichkeiten konnten nicht geladen werden",
  "volunteerPage.emptyTitle": "Keine Ehrenamtsmöglichkeiten",
  "volunteerPage.emptySubtitle": "Schauen Sie bald wieder vorbei für neue Stellen.",
};

export default translations;